export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : "—");

export const diffDaysFromToday = (date) => {
    if (!date) return null;
    const t0 = new Date();
    t0.setHours(0, 0, 0, 0);
    const d0 = new Date(date);
    d0.setHours(0, 0, 0, 0);
    return Math.round((d0.getTime() - t0.getTime()) / 86400000);
};

export const pickDate = (obj) =>
    obj?.fechaCaducidad ||
    obj?.fechaValidez ||
    obj?.fechaDeCaducidad ||
    obj?.fechaFin ||
    obj?.finVigencia ||
    null;
